import { useLazyFetch } from "../utils/apiclient";
import { devopsUrl } from "../utils/urls";
import { getHeaders } from "../utils/apiclient";

export const useGetLoggedInUser = () => {
  const out = useLazyFetch(`${devopsUrl}/users/self`, {
    headers: getHeaders(),
  });
  if (process.env.REACT_APP_AUTH_EMAIL) {
    return {
      postData: () => {},
      response: { email: process.env.REACT_APP_AUTH_EMAIL },
      responseStatus: 200,
      error: null,
      isLoading: false,
    };
  }
  return out;
};
